import React from 'react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Footer from '../../Components/Menu/Footer';

const LinkPagamentoErro: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: `linear-gradient(
          145deg,
          ${alpha(theme.palette.grey[100], 0.9)} 0%,
          ${alpha(theme.palette.error.light, 0.05)} 100%
        )`,
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 4, md: 8 }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          height: 280,
          background: `linear-gradient(
            135deg,
            ${theme.palette.error.main} 0%,
            ${alpha(theme.palette.error.main, 0.85)} 100%
          )`,
          clipPath: 'polygon(0 0, 100% 0, 100% 65%, 0 100%)',
          zIndex: 0
        }}
      />

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper
          elevation={6}
          role="alert"
          sx={{
            borderRadius: 4,
            textAlign: 'center',
            p: { xs: 4, md: 6 },
            backdropFilter: 'blur(4px)'
          }}
        >
          <ErrorOutlineIcon
            sx={{
              fontSize: 64,
              color: theme.palette.error.main,
              mb: 2
            }}
          />

          <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
            Ocorreu um erro
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Não foi possível concluir a operação. Entre em contato com o emissor da fatura para
            obter mais informações.
          </Typography>

          <Box
            component="img"
            src="/undraw_fixing-bugs_1ytu.svg"
            alt="Erro no processamento do pagamento"
            sx={{
              mt: 5,
              width: { xs: 180, sm: 220, md: 250 },
              maxWidth: '100%',
              height: 'auto',
              mx: 'auto'
            }}
          />
        </Paper>

        <Footer backgroundColor="transparent" />
      </Container>
    </Box>
  );
};

export default LinkPagamentoErro;
